<template>
  <td :class="{ 'selected-date': mark, 'current-date': markToday }">
    <a @click.prevent.stop="goToDaily">{{ dayOfMonth }}</a>
    <div
      class="have-appointment-wrapper"
      :class="{ 'monthly-appointment-wrapper': isMonthlyRouter }"
      v-if="
        selectedProviderID in appointmentDates &&
          appointmentDates[selectedProviderID].indexOf(date) !== -1
      "
    >
      <span class="have-appointment"></span>
    </div>
  </td>
</template>

<script>
import { mapGetters } from "vuex";
import { dayMixin } from "../../../mixins/dayMixin.js";

export default {
  mixins: [dayMixin],
  data() {
    return {
      months: [
        "jan",
        "feb",
        "mar",
        "apr",
        "may",
        "jun",
        "jul",
        "aug",
        "sep",
        "oct",
        "nov",
        "dec"
      ],
      isMonthlyRouter: this.$route.name.match("Monthly") ? true : false
    };
  },
  props: {
    fetchAppointmentDetails: Boolean,
    markDay: String
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  computed: {
    ...mapGetters({
      selectedDayOfMonth: "getSelectedDayOfMonth",
      selectedMonth: "getSelectedMonth",
      selectedYear: "getSelectedYear"
    }),
    mark() {
      if (this.markDay === "today") {
        return this.currentDay;
      } else {
        return (
          this.selectedDayOfMonth === this.dayOfMonth &&
          this.selectedYear === this.year &&
          this.selectedMonth + 1 === this.month
        );
      }
    },
    markToday() {
      if (this.markDay !== "today") {
        return this.currentDay;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
a {
  cursor: pointer;
}
.monthly-appointment-wrapper {
  top: 35px;
}
</style>
